import { Injectable } from '@angular/core';
import { CurrentUser } from '@shared/model/currentUser.model';

import { BaseSignalStore } from '../signal-state.util';

export interface PermissionState {
  data: Partial<CurrentUser> | any;
}

const createInitialState = (): PermissionState => ({ data: {} });

@Injectable({ providedIn: 'root' })
export class PermissionStore extends BaseSignalStore<PermissionState> {
  constructor() {
    super(createInitialState(), { name: 'permission' });
  }
}
